import { Component, computed, ElementRef, EventEmitter, HostListener, inject, Input, OnInit, Output } from '@angular/core';
import { CosmeticOptions, DisplayOptions } from '../../../models/filter-models';
import { DisplayType, Rarity } from '../../../models/enums';
import { LabelViewerComponent } from '../../label-viewer/label-viewer.component';
import { SettingsService } from '../../../services/settings.service';
import { labelPreviewBgImageStyle } from '../../label-preview-backgrounds';
import { CosmeticStyleClipboardService, StyleLibraryEntry } from '../../../services/cosmetic-style-clipboard.service';

export interface LibraryPreviewRow {
  entry: StyleLibraryEntry;
  displayOptions: DisplayOptions;
}

@Component({
  selector: 'app-style-library-picker-dialog',
  imports: [LabelViewerComponent],
  templateUrl: './style-library-picker-dialog.component.html',
  styleUrls: ['../../dialogs.scss', '../../rule-preview/label-preview-shared.scss', './style-library-picker-dialog.component.scss'],
})
export class StyleLibraryPickerDialogComponent implements OnInit {
  private readonly elementRef = inject(ElementRef);
  private readonly settings = inject(SettingsService);
  private readonly styleClipboard = inject(CosmeticStyleClipboardService);

  @Output() selected = new EventEmitter<CosmeticOptions>();
  @Output() close = new EventEmitter<void>();

  @Input() rarity?: Rarity;
  @Input() sockets?: string;
  @Input() influence?: string;
  @Input() fractured?: boolean;
  @Input() veiled?: boolean;
  @Input() isCurrency?: boolean;
  @Input() isWaystone?: boolean;
  @Input() isPoe1Gem?: boolean;
  @Input() isDivinationCard?: boolean;
  @Input() isQuestItem?: boolean;
  @Input() forceHidden?: boolean;

  labelBackgroundImage = computed(() => labelPreviewBgImageStyle(this.settings.labelPreviewBg()));

  previewRows: LibraryPreviewRow[] = [];
  hasEntries = false;
  hasMultipleEntries = false;

  ngOnInit(): void {
    this.refreshPreview();
  }

  refreshPreview() {
    const entries = this.styleClipboard.getLibraryEntries();
    this.hasEntries = entries.length > 0;
    this.hasMultipleEntries = entries.length > 1;
    this.previewRows = entries.map(entry => ({
      entry,
      displayOptions: new DisplayOptions({
        displayType: DisplayType.Custom,
        active: true,
        hidden: false,
        cosmeticOptions: new CosmeticOptions({ ...entry.options }),
      }),
    }));
  }

  clearAllButLast() {
    this.styleClipboard.clearAllButLast();
    this.refreshPreview();
  }

  selectEntry(entry: StyleLibraryEntry) {
    this.selected.emit(new CosmeticOptions({ ...entry.options }));
    this.closeDialog();
  }

  closeDialog() {
    this.close.emit();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const dialogElement = this.elementRef.nativeElement.querySelector('.dialog');
    if (dialogElement && !dialogElement.contains(event.target)) {
      this.closeDialog();
    }
  }
}
